<template>
  <div>
    <el-dialog  title="金融授信产品说明"  v-if="dataVal.status!='04'" :visible.sync="dialogVisible" width="60%" custom-class="payment_dialog" :before-close="handleClose">
        <div>
            <div class="payment_top">
                <h2>付货款，就找化工宝白条<span>纯信用、循环使用、随借随还、使用便捷</span></h2>
                <p>400-820-6662</p>
            </div>
            <div style=" display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;height: 470px;">
                <div class="payment_content">
                    <h4>产品介绍</h4>
                    <div><p>最高借款：<span>200万</span></p><p>融资费率：<span>7%年化率+1%平台服务费</span></p><p>融资期限：<span>60天</span></p></div>
                    <p style="margin:5px 0;">融资要求：在平台活跃年限大于1年、无不良平台交易记录(具体以数据实验室风控评审结果为准)</p>
                    <p>如何用款：通过平台订单在线申请用款</p>
                    <p>注：本产品由化工宝数科提供供应链金融中介服务，产品授信审核及资金提供由第三方负责。</p>
                </div>
                <div class="payment_pic">
                    <!-- <img src="../../assets/img/ksxcx.jpg" alt=""> -->
                    <img src="https://test.b-chem.com/static/finance-module/img/ewm.999be5f4.jpg" alt="">
                    <span>微信扫一扫，直接手机端操作</span>
                </div> 
            </div>

        </div>
    </el-dialog>
    <el-dialog v-else title="白条支付" :visible.sync="dialogVisible" width="60%" custom-class="payment_dialog" :before-close="handleClose">
        <div>
            <div class="payment_content payment_content1">
                <h4>{{whiteData.productName}}、{{whiteData.quality}}、合同号{{whiteData.contractCode}}<span>{{whiteData.createTime}}</span></h4>
                <p style="margin:5px 0;">交易公司：{{whiteData.tradingCompany}}</p>
                <p style="margin:5px 0;">合同总价：{{whiteData.orderAmt}}元</p>
            </div>
           <el-form style="padding:0 20px;box-sizing: border-box;" ref="ruleForm" :rules="rules" label-position="left"  :model="ruleForm"  >
                <el-form-item label="本次付款金额：" prop="payAmount" label-width="125px">
                    <el-input style="width:50%" type="number" v-model="ruleForm.payAmount"><template slot="append">元</template></el-input>
                    <span class="span_color">企业可用额度：{{dataVal.usableAmount}}元</span>
                </el-form-item>
                <el-form-item label="收款方账号：" prop="bankType" label-width="125px">
                    <el-select style="width:50%" v-model="ruleForm.bankType"  placeholder="请选择">
                        <el-option v-for="(item,index) in optionList" :key="index" :label="item.title" :value="item.bankType"></el-option>
                    </el-select>
                    <p class="p_color">请认真核对收款方银行账号信息</p>
                </el-form-item>
                <el-form-item label-width="125px">
                    <el-button  type="warning" @click="onSubmit">申请白条支付</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/utils/http'; // 导入http中创建的axios实例
export default {
    props: {
        // 弹框是否打开
        isDialog: {
            type: Boolean,
            default: false,
        },
        whiteData:{
            type: Object,
            default:{
                productName:'',//产品名称
                quality:'',//质量
                contractCode:'',//合同号
                createTime:'',//创建时间
                tradingCompany:'',//交易公司
                orderAmt:null,//总金额
            },
        }
    },
    watch:{
        isDialog:{ 
            handler(newV, oldV) {
                this.getWhiteSign()
                // console.log(this.whiteData);
            },
        },
    },
    data() {
        var payAmount =(rule, value, callback) => {
            if(value<=0){
                callback( new Error('付款金额需大于0'));
                this.ruleForm.payAmount=null
            }else{
                if(value>this.dataVal.usableAmount){
                    callback( new Error('付款金额超出企业可用额度'));
                }else{
                    callback();
                }
                
            }
        }
      return {
        dialogVisible: false,
        ruleForm:{
            payAmount:null,
            bankType:''
        },
        rules: {
          payAmount: [
            { required: true, message: '请输入付款金额', trigger: 'blur' },
             { validator: payAmount, trigger: "blur" },
          ],
          bankType: [
            { required: true, message: '请选择收款方账号', trigger: 'change' }
          ],
        },
        // 查账户信息
        dataVal:{
            status:'',
            usableAmount:null
        },
        optionList:[],
      };
    },
    methods:{
        //查询用户的授信额度
        getWhiteSign(){
              const loading = this.$loading({
                //lock的修改符--默认是false
                lock: true,
                //显示在加载图标下方的加载文案
                text: "数据加载中",
                //自定义加载图标类名(在elementUI 文档查找)
                spinner: "el-icon-loading",
                //(可以自己定义)遮罩层颜色
                background: "rgba(255, 255, 255, .7)",
                //loadin覆盖的dom元素节点(整个页面的话'#body' 表格的话'#table'等等 )
                target: document.querySelector("#loadingBox1111"),
            });
            // postQueryCreditBaseInfo
            let formData = new FormData();
            formData.append("companyCode", JSON.parse(localStorage.getItem('companyInfo')).bspCompanyCode);
            this.$api.twice.postQueryCreditBaseInfo(formData).then(res=>{
            //   console.log(res);
              loading.close();
              if(res.code=='200'){
                this.dataVal=res.data
                this.dialogVisible= true 
                this.getPayInfo()
                
              }else{
                this.$message.error(res.message)
              }
            })
        },
        //// 查询收款方信息
        async getPayInfo(){
            // this.whiteData.companyCode
             await this.$api.twice.getCreditClientPayInfo({companyCode:this.whiteData.companyCode}).then(res=>{
                // console.log(res);
                if(res.code=='200'){
                    res.data.forEach(item=>{
                        item.title=item.bankTypeValue+'-'+item.bankName+'-'+item.bankAccount
                    })
                    this.optionList=res.data
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        handleClose(){
            this.dialogVisible = false
            this.ruleForm={
                payAmount:null,
                bankType:''
            }
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields()
            }
            
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                let bankData=this.optionList.filter(e=>{return  this.ruleForm.bankType==e.bankType})[0]||{}
                // console.log(bankData);
                let params={
                    ouCompanyCode:JSON.parse(localStorage.getItem('companyInfo')).bspCompanyCode,//  付款方公司代码
                    ouCompanyName:JSON.parse(localStorage.getItem('companyInfo')).companyName ,//  付款方公司名称

                    orderNo:this.whiteData.contractCode ,//  合同号
                    payAmount:this.ruleForm.payAmount,//  付款金额
                    // this.whiteData.companyCode
                    supplierCompanyCode:this.whiteData.companyCode,//  收款方公司代码
                    supplierCompanyName:this.whiteData.tradingCompany,//  收款方公司名称

                    receiveBankCode:bankData.bankType,//  收款方银行代码
                    // receiveBankName:bankData.bankName,//  收款方银行名称
                    // receiveAccountName:bankData.bankTypeValue,// 收款方开户名
                    receiveBankName:bankData.bankTypeValue,//  收款方银行名称
                    receiveAccountName:bankData.balanceName,//收款方开户名

                    receiveBankNum:bankData.bankAccount,//  收款方银行账号

                    companyCode:JSON.parse(localStorage.getItem('companyInfo')).bspCompanyCode, // 公司代码
                    companyName:JSON.parse(localStorage.getItem('companyInfo')).companyName, //  公司名称
                    userCode:JSON.parse(localStorage.getItem('info')).account, //登录人账号
                    userName:JSON.parse(localStorage.getItem('companyInfo')).userName, // 登录人姓名

                    source:"bwty-ks",//支付来源 
                }
                this.$api.twice.postWhiteSlipPayment(params).then(res=>{
                    // console.log(res);
                    if(res.code==200){
                        this.$message.success(res.message)
                        this.handleClose()
                    }else{
                        this.$message.error(res.message)
                    }
                })
            } else {
                // console.log('error submit!!');
                return false;
            }
            });
        },
    },
};
</script>

<style scoped>
::v-deep .payment_dialog{
    border-radius: 10px;
}
::v-deep .payment_dialog .el-dialog__body{
    padding-top: 10px;
     box-sizing: border-box;
}
.payment_top{
    background: url('http://ax.b-chem.cn/pro/3NYe7R7ZeBM/images/%E7%A2%B3%E4%B8%9A%E5%AE%A2%E5%95%86%E6%9C%8D%E5%8A%A1pc%E7%AB%AF/u30.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px 5px 120px;
    box-sizing: border-box;
}
.payment_top h2{
    font-size: 24px;
    font-weight: bold;
}
.payment_top h2 span{
    font-size: 14px;
    font-weight: normal;
    margin-left: 30px;
}
.payment_top p{
    font-size: 18px;
    font-style: italic;
}
.payment_content{
    padding: 20px;
    box-sizing: border-box;
}
.payment_content h4{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}
.payment_content h4 span{
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 10px;
    margin-left: 30px;
}
.payment_content div{
    display: flex;
}
.payment_content div p{
    margin-right: 40px;
}
.payment_content div p span{
    font-weight: bold;
}
.payment_content1 p{
    font-size: 16px;
}
.payment_pic{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}
.payment_pic img{
    width: 250px;
    height: 250px;
    display: block;
    margin-bottom: 20px;
}
.span_color{
    color: #67C23A;
    margin-left: 50px;
}
.p_color{
    color: red;
    font-weight: bold;
}
</style>
